export enum StripeCommonPaymentError {
  CARD_DECLINED = 'card_declined',
  EXPIRED_CARD = 'expired_card',
  INSUFFICIENT_FUNDS = 'insufficient_funds',
  INCORRECT_CVC = 'incorrect_cvc',
  INCORRECT_NUMBER = 'incorrect_number',
  PROCESSING_ERROR = 'processing_error',
  AUTHENTICATION_REQUIRED = 'authentication_required',
}

export const STRIPE_CARD_DECLINED_PAYMENT_ERROR_DESCRIPTION = "La tua carta è stata rifiutata. Contatta l'emittente della carta per maggiori dettagli o utilizza un altro metodo di pagamento" as const; // card_declined
export const STRIPE_EXPIRED_CARD_PAYMENT_ERROR_DESCRIPTION = "La tua carta è scaduta. Aggiorna i dettagli della carta per continuare" as const; // expired_card
export const STRIPE_INSUFFICIENT_FUNDS_PAYMENT_ERROR_DESCRIPTION = "Fondi insufficienti sulla carta. Usa un altro metodo di pagemento" as const; // insufficient_funds
export const STRIPE_INCORRECT_CVC_PAYMENT_ERROR_DESCRIPTION = "Il codice di sicurezza della carta (CVC) è errato. Riprova" as const; // incorrect_cvc
export const STRIPE_INCORRECT_NUMBER_PAYMENT_ERROR_DESCRIPTION = "Il numero della carta inserito non è valido. Riprova" as const; // incorrect_number
export const STRIPE_PROCESSING_ERROR_PAYMENT_ERROR_DESCRIPTION = "Si è verificato un errore durante l'elaborazione del pagamento. Riprova" as const; // processing_error
export const STRIPE_AUTHENTICATION_REQUIRED_PAYMENT_ERROR_DESCRIPTION = "Autorizzazione richiesta. la carta impostata richiede l'autorizzazione per completare il pagamento" as const; // authentication_required

export const STRIPE_GENERIC_PAYMENT_ERROR_DESCRIPTION = "Si è verificato un errore durante il pagamento. Riprova o contatta l'assistenza" as const;

export const STRIPE_PAYMENT_ERROR_DESCRIPTIONS = [
  STRIPE_CARD_DECLINED_PAYMENT_ERROR_DESCRIPTION,
  STRIPE_EXPIRED_CARD_PAYMENT_ERROR_DESCRIPTION,
  STRIPE_INSUFFICIENT_FUNDS_PAYMENT_ERROR_DESCRIPTION,
  STRIPE_INCORRECT_CVC_PAYMENT_ERROR_DESCRIPTION,
  STRIPE_INCORRECT_NUMBER_PAYMENT_ERROR_DESCRIPTION,
  STRIPE_PROCESSING_ERROR_PAYMENT_ERROR_DESCRIPTION,
  STRIPE_AUTHENTICATION_REQUIRED_PAYMENT_ERROR_DESCRIPTION,
] as const;

export const STRIPE_PAYMENT_ERRORS: Record<string, string> = {
  [StripeCommonPaymentError.CARD_DECLINED]: STRIPE_CARD_DECLINED_PAYMENT_ERROR_DESCRIPTION,
  [StripeCommonPaymentError.EXPIRED_CARD]: STRIPE_EXPIRED_CARD_PAYMENT_ERROR_DESCRIPTION,
  [StripeCommonPaymentError.INSUFFICIENT_FUNDS]: STRIPE_INSUFFICIENT_FUNDS_PAYMENT_ERROR_DESCRIPTION,
  [StripeCommonPaymentError.INCORRECT_CVC]: STRIPE_INCORRECT_CVC_PAYMENT_ERROR_DESCRIPTION,
  [StripeCommonPaymentError.INCORRECT_NUMBER]: STRIPE_INCORRECT_NUMBER_PAYMENT_ERROR_DESCRIPTION,
  [StripeCommonPaymentError.PROCESSING_ERROR]: STRIPE_PROCESSING_ERROR_PAYMENT_ERROR_DESCRIPTION,
  [StripeCommonPaymentError.AUTHENTICATION_REQUIRED]: STRIPE_AUTHENTICATION_REQUIRED_PAYMENT_ERROR_DESCRIPTION,
}